import React from 'react';
import styled from 'styled-components';
import T from 'aegisv2/Text';

const Title = styled(T)`
  color: ${props => props.theme.colors.mainText};
  display: block;
  margin-bottom: 12px;
`;

// eslint-disable-next-line react/prop-types
export default ({ children }) => (
  <Title s bold>
    {children}
  </Title>
);
